export default "__VITE_ASSET__cc2bdd82__"